module.exports = __webpack_public_path__ + "static/gm-31-ef5a89349a443b5f63fb1ff611a9ce2c.jpg";